import { LinkOverlay as ChakraLinkOverlay } from '@chakra-ui/react';

export const LinkOverlay = ChakraLinkOverlay;
